import { useContext, useMemo } from "react";
import { useCsAttributes, useSelectorOptionDefaults, } from "@plansoft-configuration-renderer/framework";
import { ViewLevelEnabledContext } from "../Settings/ViewLevelEnabledContext";
import { computeCompleteness } from "./helpers/computeCompleteness";
import { computeVisibleLayout } from "./helpers/computeVisibleLayout";
import { removeInactiveAttributes } from "./helpers/removeInactiveAttributes";
export function useComputeVisibleLayout(layout) {
    const attributes = useCsAttributes();
    const viewLevelEnabled = useContext(ViewLevelEnabledContext);
    const { includeNotActive, includeNotVisible } = useSelectorOptionDefaults();
    const visibleLayout = useMemo(() => {
        // default: keep existing layout
        let visibleLayout = layout;
        if (viewLevelEnabled) {
            // calculate layout
            visibleLayout = computeVisibleLayout(layout, attributes);
        }
        else if (!(includeNotActive || includeNotVisible)) {
            visibleLayout = removeInactiveAttributes(layout, attributes);
        }
        //  compute completeness
        return computeCompleteness(visibleLayout, attributes);
    }, [
        layout,
        attributes,
        viewLevelEnabled,
        includeNotActive,
        includeNotVisible,
    ]);
    return visibleLayout;
}
//# sourceMappingURL=useComputeVisibleLayout.js.map